import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faHexagon } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './FabButton.css'

export type FabButtonColor = 'accent' | 'blue' | 'orange'

type Props = {
  icon: IconDefinition
  title: string
  color?: FabButtonColor
  href?: string
  disabled?: boolean
  badge?: string | number
  onClick?: () => void
}

const FabButton = ({ icon, title, color = 'accent', href, disabled, badge, onClick }: Props) => {
  const className = `fab-button fab-button--${color}${disabled ? ' fab-button--disabled' : ''}`

  const content = <>
    <FontAwesomeIcon className="fab-button__hexagon" icon={faHexagon} />
    <span className="fab-button__foreground">
      <FontAwesomeIcon icon={icon} fixedWidth />
      {badge !== undefined && <span className="fab-button__badge">{badge}</span>}
    </span>
  </>

  if (href && !disabled) {
    return <a className={className} href={href} title={title} aria-label={title}>{content}</a>
  }

  return <button
    className={className}
    type="button"
    title={title}
    aria-label={title}
    disabled={disabled}
    onClick={onClick}
  >{content}</button>
}

export default FabButton
